<div
  class="text-center"
  style="width: 300px; position: absolute; height: 50vh; top: 45%"
  *ngIf="loading"
>
  <mat-spinner
    [diameter]="25"
    strokeWidth="3"
    color="accent"
    style="display: inline-block"
  ></mat-spinner>
</div>

<div class="ag-pa-md">
  <div *ngIf="!loading && tracking && page1" class="email-list">
    <h4>Guest Tracking</h4>
    <br />
    <h6>{{ tracking?.loginInstructions }}</h6>
    <br />
    <form (ngSubmit)="submitForm(guestForm)" [formGroup]="guestForm">
      <div class="form-group">
        <label for="Username"> {{ tracking?.usernameLabel }}</label>
        <input
          type="text"
          class="form-control"
          id="username"
          title="User Name"
          formControlName="Username"
          aria-describedby="usernameHelp"
          placeholder="Enter Username"
        />
      </div>
      <div class="form-group">
        <label for="Username"> {{ tracking?.passwordLabel }}</label>
        <input
          type="password"
          class="form-control"
          title="Password"
          formControlName="Password"
          aria-describedby="usernameHelp"
          placeholder="Enter Password:"
        />
      </div>
      <button
        role="button"
        aria-label="Submit"
        type="submit"
        class="btn btn-primary"
        [disabled]="!guestForm.valid"
      >
        Submit
      </button>
    </form>
  </div>

  <div *ngIf="!page1 && requests" class="email-list">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <a
            style="text-decoration: underline; cursor: pointer"
            tabindex="0"
            (click)="back()"
            (keyup.enter)="back()"
          >
            <h5>Back</h5>
          </a>
        </div>
      </div>
      <br />
      <div class="row">
        <div class="col-12">
          <div *ngIf="this.limitMessage !== ''">
            <b>{{ limitMessage }}</b>
          </div>
        </div>
      </div>
      <!-- <hr style="border-color:var(--header-color);width:100%"> -->
      <div class="row">
        <div class="col-12" *ngIf="items.length > 0">
          <!-- <div class="per-items">
          <div class="device-only d-block d-lg-none col-12 clearfix"> -->
          <!-- <div *ngFor="let item of requests?.items"> -->
          <div class="quick-content" *ngFor="let item of items">
            <hr style="border-color: var(--header-color)" />
            <h5 *ngIf="item">Request Details</h5>
            <div *ngIf="item?.requestId">
              ID:
              <b>{{ item?.requestId }}</b>
            </div>
            <div *ngIf="item?.requestDate">
              Date:
              <b>{{ item?.requestDate }}</b>
            </div>
            <div *ngIf="item?.needByDate">
              Need By:
              <b>{{ item?.needByDate }}</b>
            </div>
            <div *ngIf="item?.documentURL !== null && item?.documentURL !== ''">
              <a
                class="a-link"
                tabindex="0"
                (click)="onNavigate(item?.documentURL)"
                (keyup.enter)="onNavigate(item?.documentURL)"
                >Electronic Attachment</a
              >
            </div>
            <div *ngFor="let info of item?.documentInfo" class="margin-top-5">
              <span
                ><strong>{{ info?.fileName }}</strong> {{ info?.message }}</span
              >
            </div>
            <div *ngIf="item?.showPickupLocations">
              Pick Up Location:
              <b>{{ item?.showPickupLocations }}</b>
            </div>
            <div *ngIf="item?.currentPickupLocation">
              Current Location:
              <b>{{ item?.currentPickupLocation }}</b>
            </div>
            <br />
            <h5 *ngIf="item">Item Details</h5>
            <div *ngIf="item?.title">
              Title:
              <b>{{ item.title }}</b>
            </div>
            <div *ngIf="item?.author">
              Author:
              <b>{{ item?.author }}</b>
            </div>
            <div *ngIf="item?.pubYear">
              Pub Year:
              <b>{{ item?.pubYear }}</b>
            </div>
            <div *ngIf="item?.status">
              Status:
              <b>{{ item?.status }}</b>
            </div>
            <br />
            <!-- <div *ngIf='!item.pickupLocations === [""]'>
                          <label>Pickup Locations:</label>
                          <select #options2>
                            <option *ngFor="let options of item.pickupLocations"></option>
                          </select>
                        </div> -->
            <!-- <hr style="border-color:var(--header-color);width:100%"> -->
          </div>
          <!-- </div> -->
          <!-- </div>
        </div> -->
        </div>
      </div>
    </div>
  </div>
</div>
